<template>
  <y-view :loading="isLoading">
    <k-table :data="arrDataList" has-index :pageIndex="para.pageCurrent" :pageSize="para.pageSize"
      max-height="calc(100vh - 100px)" :rightFixedNumber="1" :leftFixedNumber="2" :columns="initColumns()"></k-table>
    <k-popup :show.sync="isShowPopup" title="关闭打款" @after-ok="onSave">
      <y-popup-body size="big">
        <div class="k-input-section k-input-medium" style="width: 100%;margin-bottom: 10px;">
          <textarea style="width: 100%;height: 200px;" height="200px" v-model="reason" rows="4" placeholder="请输入关闭打款原因"
            class="k-textarea k-input--left"></textarea>
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>
<script>
  /**
   * @name: 
   * @description: 对公账单明细
   * @author: zhaoliubin@yuouhui.com
   * @create: 2020-10-09 09:19:02
   * @update: 2020-10-09 09:19:02
   */
  // import Mock from 'mockjs';
  export default {
    props: {
      remitNo: '',
      remitType: '',
    },
    data() {
      return {
        isShowPopup: false,
        para: {
          remitNo: '',
          remitType: '',//打款类型:1对私,2对公
        },
        objCurrentItem: {},
        total: 0,
        arrDataList: [],
        isLoading: false,
        objStatusList: {
          0: "待审核",
          1: "审核成功",
          2: "待打款",
          3: "已提交",
          4: "已完成",
          5: "打款失败",
          6: "拒绝",
        },
      };
    },
    methods: {
      initColumns() {
        return [
          {
            name: "申请提现单号",
            field: "withdrawNo",
            style: {
              width: 110,
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: "打款金额",
            field: "amount",
            style: {
              width: 100,
            },
          },
          {
            name: "用户姓名",
            field: "shopMemberName",
            style: {
              width: 100,
              "white-space": "normal",
            },
          },
          {
            name: "分销角色",
            field: "shopMemberTypeName",
            style: {
              width: 100,
              "white-space": "normal",
            },
          },
          {
            name: "客商名称",
            field: "customerName",
            style: {
              width: 80,
              "white-space": "normal",
            },
          },
          {
            name: "银行名称",
            field: "bankName",
            style: {
              width: 100,
              "white-space": "normal",
            },
          },
          {
            name: "开户行",
            field: "depositBank",
            style: {
              width: 80,
              'white-space': 'normal',
            },
          },
          {
            name: "行号",
            field: "bankNumber",
            style: {
              width: 80,
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: "账户名称",
            field: "accountName",
            style: {
              width: 80,
              'white-space': 'normal'
            },
          },
          {
            name: "银行账号",
            field: "bankCardNumber",
            style: {
              width: 120,
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: "银行预留手机号",
            field: "bankReservedPhone",
            style: {
              width: 120,
            },
          },
          {
            name: "状态",
            field: "statusName",
            style: {
              width: 80,
            },
            // customRender: (row) => {
            //   return <p>{this.objStatusList[row.status]}</p>;
            // },
          },
          {
            name: "打款失败原因",
            field: "failReason",
            style: {
              width: 100,
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: "创建时间",
            field: "createTime",
            style: {
              width: 140,
            },
          },
          {
            name: "操作",
            field: "",
            style: {
              width: 100,
            },
            customRender: (row) => {

              if (this.para.remitType == 2) {//对公
                const btnSubmit = <a
                  href="javascript:void(0);"
                  onClick={() => {
                    this.onConfirmSubmit(row);
                  }}
                >
                  提交&#12288;
                  </a>
                // const btnConfirm = (
                //   <a
                //     href="javascript:void(0);"
                //     onClick={() => {
                //       this.onConfirmPay(row);
                //     }}
                //   >
                //     确认打款
                //   </a>
                // );
                const btnFinish = (
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      this.onFinishPay(row);
                    }}
                  >
                    打款完成
                  </a>
                );
                return (
                  <div>
                    {row.status == 2 ? btnSubmit : ''}  {row.status == 3 ? btnFinish : ''}
                  </div>
                );
              } else {
                const btnSubmit = (
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      this.onConfirmSubmit(row);
                    }}
                  >
                    提交&nbsp;&nbsp;
                  </a>);
                const btnClose = (
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      this.onConfirmClose(row);
                    }}
                  >
                    关闭打款
                  </a>
                )
                return (
                  <div>
                    {row.status == 2 || row.status == 5 ? btnSubmit : ''}{row.status == 5 ? btnClose : ''}
                  </div>
                )
              }
            },
          },
        ];
      },
      initPageData() {
        let para = this.para;
        this.isLoading = true;
        let api = this.para.remitType == 1 ? '/nestle-finance-back-server/remit-private/detail' : '/nestle-finance-back-server/remit-public/detail';
        this.$fetch({
          api,
          para,
        }).then((res) => {
          this.arrDataList = res.withdrawVOList;
          this.total = res.total;
          this.isLoading = false;
        });
      },
      onConfirmPay(row) {
        let api = this.para.remitType == 2 ? '/nestle-finance-back-server/remit-public/comfirm-remit' : '/nestle-finance-back-server/remit-private/comfirm-remit';
        this.$dialog({
          title: "确认打款",
          content: `是否确认向账单：${row.withdrawNo}打款？`,
          ok: () => {
            this.$fetch({
              api,
              para: {
                id: row.id
              },
              isSuccessTip: true,
            })
              .then((res) => {
                this.initPageData();
              })
              .catch(() => { });
          },
          cancel: () => { },
        });
      },
      onFinishPay(row) {
        this.$dialog({
          width: '300px',
          title: "打款完成",
          content: `是否确认打款完成：${row.withdrawNo}?`,
          ok: () => {
            this.$fetch({
              api: '/nestle-finance-back-server/remit-public/callback-remit',
              para: {
                id: row.id,
                withdrawNo: row.withdrawNo,
              },
              isSuccessTip: true,
            }).then(res => {
              this.initPageData();
            }).catch(() => {
            });
          },
          cancel: () => { },
        });
      },
      onConfirmSubmit(row) {
        let api = this.para.remitType == 2 ? '/nestle-finance-back-server/remit-private/submit-remit' : '/nestle-finance-back-server/remit-private/submit-remit'
        this.$dialog({
          width: '300px',
          title: "提交",
          content: `是否确认提交打款单：${row.withdrawNo}?`,
          ok: () => {
            this.$fetch({
              api,
              para: {
                id: row.id
              },
              isSuccessTip: true,
            }).then(res => {
              this.initPageData();
            }).catch(() => {
            });
          },
          cancel: () => { },
        });
      },
      onConfirmClose(row) {
        this.objCurrentItem = row;
        this.reason = '';
        this.isShowPopup = true;
      },
      onSave() {
        if (!this.reason) {
          return this.$root.tip('请输入原因');
        }
        this.$fetch({
          api: 'nestle-finance-back-server/remit-private/close-remit',
          para: {
            id: this.objCurrentItem.id,
            reason: this.reason,
          },
          isSuccessTip: true,
        }).then(res => {
          this.isShowPopup = false;
          this.initPageData();
        }).catch(() => {

        });
      },
    },

    created() {
      // ({ remitNo: this.para.remitNo, remitType: this.para.remitType } = this.$route.query);
      this.para.remitNo = this.remitNo;
      this.para.remitType = this.remitType;
      this.initPageData();
    },
    watch: {
      'remitNo'(newVal) {
        console.log(newVal);

        this.para.remitNo = this.remitNo;
        this.para.remitType = this.remitType;
        this.initPageData();
      },
    }
  };
</script>

<style lang="postcss" module="css"></style>